import { clsx } from 'clsx';
import { HTMLAttributes } from 'react';

import './TextEllipsis.css';

export type TextEllipsisProps = HTMLAttributes<HTMLSpanElement>;

export const TextEllipsis = ({ className, ...textProps }: TextEllipsisProps) => {
  return <span className={clsx('text-ellipsis', className)} {...textProps} />;
};
